export default {
  calendar: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  clients: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  // {{NEXT}}
}
